var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirthServers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 17.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    className: "cls-1",
    d: "M2.2,0C1,0,0,1,0,2.2s1,2.2,2.2,2.2H15.8c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H2.2Zm0,1.6c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7m2.7,0c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7m2.7,0c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7M2.2,6.3c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2H15.8c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H2.2Zm0,1.6c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7m2.7,0c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7m2.7,0c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7M2.2,12.6c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2H15.8c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H2.2Zm0,1.6c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7m2.7,0c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7m2.7,0c.4,0,.7,.3,.7,.7s-.3,.7-.7,.7-.7-.3-.7-.7,.3-.7,.7-.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirthServers);
export default __webpack_public_path__ + "static/media/mirth-servers.fc96855ca7bb7721c7e5db540eb02048.svg";
export { ForwardRef as ReactComponent };